module.exports = new __parcel__URL__("report-resolution-time.77b24ed9.svg").toString();